export const API_URL = "https://admin.booktable.co.in/api/";
export const MAIN_API_URL = "https://app.booktable.co.in/api/";
// export const API_URL = "http://localhost:3010/api/";
// export const MAIN_API_URL = "http://localhost:3020/api/";